<script>
import { mapGetters } from "vuex";
import { formatCompact } from "@/shared/utils/formatters";
import EmployeeBySex from "@/components/modules/new-dashboard/components/employees-by-sex/employee-by-sex.vue";
import DashboardTotal from "@/components/modules/new-dashboard/components/dashboard-total.vue";
import TrackerEmployeeBySex
  from "@/components/modules/tracker-dashboard/components/tracker-employees-by-sex/tracker-employee-by-sex.vue";

export default {
  name: "TrackerEmployeesBySexWidget",
  components: {TrackerEmployeeBySex, DashboardTotal, EmployeeBySex },
  data: function () {
    return {
      employeesBySex: {
        women: 0,
        men: 0,
        percentageWomen: this.formatPercentage(
          0
        ),
        percentageMen: this.formatPercentage(
          0
        ),
      },
    };
  },
  computed: { ...mapGetters(["getTrackerImpactedWorkers"]) },
  watch: {
    getTrackerImpactedWorkers: {
      handler:function() {
        this.formatEmployeesBySex();
      },
      deep: true,
    }
  },
  mounted() {
    this.formatEmployeesBySex();
  },
  methods: {
    formatCompact,
    formatEmployeesBySex: function () {
      var total = this.getTotalEmployees();

      this.employeesBySex = {
        women: this.getTrackerImpactedWorkers.data.women ?? 0,
        men: this.getTrackerImpactedWorkers.data.men ?? 0,
        percentageWomen: this.formatPercentage(
          100 * (total > 0 ? this.getTrackerImpactedWorkers.data.women / total : 0) ?? 0
        ),
        percentageMen: this.formatPercentage(
          100 * (total > 0 ? this.getTrackerImpactedWorkers.data.men / total : 0) ?? 0
        ),
      };
    },
    formatPercentage: function (percentage) {
      return +percentage.toFixed(0) + "%";
    },
    getTotalEmployees: function () {
      return ( this.getTrackerImpactedWorkers.data.women??0) + (this.getTrackerImpactedWorkers.data.men ?? 0);
    },
  },
};
</script>

<template>
  <div style="
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
">
  <div v-if="getTrackerImpactedWorkers.loading" class="loading">
    <!--    <VueSpinner size="20" color="#213a7a" />-->
  </div>
  <div v-if="!getTrackerImpactedWorkers.loading" style="cursor: pointer">
    <div class="employees-by-sex">
      <tracker-employee-by-sex
        sex="women"
        :percentage="employeesBySex.percentageWomen"
        :total="employeesBySex.women"
      />
      <div class="sex-divider" />
      <tracker-employee-by-sex
        sex="men"
        :percentage="employeesBySex.percentageMen"
        :total="employeesBySex.men"
      />
    </div>
    <dashboard-total :total-organizations="getTotalEmployees()"></dashboard-total>
  </div>
  </div>
</template>

<style lang="scss" scoped>
.employees-by-sex {
  padding-top: 10px;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 3;
  grid-row-end: 4;
}

.employees-by-sex {
  display: flex;
  justify-content: center;
  gap: 32px;
}

.sex-divider {
  background-color: #ebece4;
  width: 2px;
}

.loading {
  height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.baseline-vs-improved-by-dimensions-footer {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding-top: 15px;

  &-left {
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #4f4e4e;
  }

  &-right {
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #2f60a6;
  }
}
</style>
<style lang="scss">
.employees-by-sex-modal-container {
  .employees-by-sex {
    flex-wrap: wrap;
  }
  .sex-percentage-container {
    .sex-total {
      font-size: 7vh !important;
    }
    .sex-percentage {
      font-size: 3.5vh !important;
    }
    img {
      width: min(22vh, 13vw) !important;
    }
  }
  .baseline-vs-improved-by-dimensions-footer-left,
  .baseline-vs-improved-by-dimensions-footer-right {
    font-size: 4vh !important;
  }
}
</style>
